import { render } from "./BureauCount.vue?vue&type=template&id=2d71fef2&scoped=true"
import script from "./BureauCount.vue?vue&type=script&lang=js"
export * from "./BureauCount.vue?vue&type=script&lang=js"

import "./BureauCount.vue?vue&type=style&index=0&id=2d71fef2&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d71fef2"]])

export default __exports__